var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1511B",
    d: "M121.666 121.666H0V0h121.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#80CC28",
    d: "M256 121.666H134.335V0H256z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ADEF",
    d: "M121.663 256.002H0V134.336h121.663z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC09",
    d: "M256 256.002H134.335V134.336H256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.dc7f7539fed6473006632e8d7fe65b34.svg";
export { ForwardRef as ReactComponent };